import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { CircularProgress } from 'material-ui/Progress';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import ContinueButton from '../../common/components/Buttons/ContinueButton';
import ProductCard from '../../common/components/FormStepper/ProductCard';
import colors from '../../../config/themeColors';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: `calc(100% - ${unit * 3}px)`,
        paddingBottom: '24px',
        paddingTop: '16px',
    },
    gridContainer: {
        margin: unit,
    },
    quickQuote: {
        padding: unit * 2,
        margin: unit * 2,
    },
    button: {
        marginLeft: unit * 2,
    },
    buttonEmail: {
        marginLeft: unit * 2,
        borderRadius: 3,
        border: 0,
        color: colors.black,
        height: 36,
        padding: '0 10px',
        backgroundColor: colors.white,
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.12)',
    },
});

function SampleProducts(props) {
    const next = () => {
        props.setStep(2);
        props.setStepCompleted(1, true);
        props.setSampleProducts(props.applicationId);
    };
    return props.isPending
        ? (
            <div className={props.classes.root}>
                <CircularProgress />
            </div>
        )
        : (
            <div className={props.classes.root}>
                {props.products.length === 0 &&
                    <Typography variant="headline" component="h4">
                        There no products available for this search criteria
                    </Typography>
                }
                <Grid
                    container
                    spacing={16}
                    className={props.classes.gridContainer}
                >
                    {props.products.map(product => (
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            key={product.productCode}
                        >
                            <ProductCard
                                product={product}
                            />
                        </Grid>
                    ))}
                </Grid>
                <div>
                    <Button
                        className={props.classes.button}
                        color="default"
                        onClick={() => props.setStep(0)}
                    >
                        Back
                    </Button>
                    {props.products.length > 0 &&
                        <Button
                            className={props.classes.buttonEmail}
                            color="default"
                        >
                            Send Email
                        </Button>
                    }
                    <ContinueButton
                        className={props.classes.button}
                        onClick={() => next()}
                    />
                </div>
            </div>
        );
}

SampleProducts.propTypes = {
    isPending: PropTypes.bool.isRequired,
    products: PropTypes.array.isRequired,
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setSampleProducts: PropTypes.func.isRequired,
    applicationId: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SampleProducts);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SampleProducts/SampleProducts.js